define('controllers/cancelvacation',['require'],function(require) {
    return function() {
        var trackCancel = window.ServerData.feData.trackCancel;
        if (trackCancel != null) {
            gaTrack('conversions', 'CancelBooking', trackCancel.vacDestID, trackCancel.total);
        }
    };
});
